export const frenchForm = "https://redcap.montfort.on.ca/redcap/surveys/?s=K3NPTWMW93FTXMRL";
export const englishForm = "https://redcap.montfort.on.ca/redcap/surveys/?s=NYA8PXRWHYY83DLT";
